import React from 'react'

function CommonObjects() {
    return (
        <div>
        
        </div>
    )
}

export function CreateButton(_id, _class, _function, _name, Icon){
    if(Icon === "")
    {
        return (
            <div>
                <button id={_id} className={_class} onClick={_function}>{_name}</button>
            </div>
        )
    } else {
        return (
            <div>
                <button id={_id} className={_class} onClick={_function}><Icon style={{marginRight:"5px"}}/> {_name}</button>
            </div>
        )
    }
    
}

export function CreateButton2(_id, _class, _function, _name, Icon){
    if(Icon === "")
    {
        return (
            <div>
                <button id={_id} className={_class} onClick={_function}>{_name}</button>
            </div>
        )
    } else {
        return (
            <div>
                <button id={_id} className={_class} onClick={_function}>{_name}<Icon style={{marginLeft:"5px"}}/></button>
            </div>
        )
    }
    
}

export function CreateSearchBar(_id, _classHead, _classIcon, _classInput, _function, Icon){
    return  (
        <div className={_classHead}>
            <div className={_classIcon}><Icon/></div>
            <div className={_classInput}><input id={_id} placeholder="Search" onChange = {_function}/></div>
        </div>
    )
}
export function CreateSearchBarWithPlaceHolder(_id, _classHead, _classIcon, _classInput, _function, _placeHolder, Icon){
    return  (
        <div className={_classHead}>
            <div className={_classIcon}><Icon/></div>
            <div className={_classInput}><input id={_id} placeholder={_placeHolder} onChange = {_function}/></div>
        </div>
    )
}



export default CommonObjects
